require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-askandyoushallget.json") })
        }
      }, "path---insights-askandyoushallget");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-askandyoushallget!./.cache/json/insights-askandyoushallget.json
// module id = 1093
// module chunks = 231608221292675